import React from 'react';
import logo from '../../assets/img/logo.png'

class GameInactive extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			childId : '',
			signupUrl : 'http://signup.compassion.com.au/'
		}

		this.handleInputChange = this.handleInputChange.bind(this);
	}

	// componentDidMount() {
	// }

	handleInputChange(event) {
		console.log('e',event.target.value);

		let id = event.target.value;
		this.setState({childId: id});

		if(id) {
			this.setState({signupUrl: 'http://signup.compassion.com.au/confirm/' + id});
		}
	}

	render() {

		return <article className="end-game">

			<header className="header">
				<h1>{this.props.game.name}</h1>
			</header>

			<main className="ridged">

				<div className="logo">
					<img src={logo} alt="compassion logo"/>
				</div>

				<section className="content">

					<h2>The Game Has Ended</h2>

					<div className="end-text">
						<p>Thank you for joining us in The Village. We hope you left feeling empowered to make a difference for those who struggle to survive.</p>
						<p>Follow Compassion to stay connected and learn more:</p>
					</div>

					<div className="share">
						<a className="button -instagram -icon" href="https://www.instagram.com/compassionau/" target="_blank">Instagram</a>
						<a className="button -facebook -icon" href="https://www.facebook.com/CompassionAU/" target="_blank">Facebook</a>
					</div>

				</section>

				<section className="content sponsor-section">
					<div className="sponsor-text">
						<p><strong>If you've decided to sponsor a child:</strong></p>
					</div>

					<div className="sponsor">
						<div className="field">
							<label>Sponsor Child ID (Optional)</label>
							<input type="text" value={this.state.childId} onChange={this.handleInputChange} placeholder="Child ID (Optional)" />
						</div>
						<a className="button -primary -huge -send -icon" href={this.state.signupUrl} target="_blank">Sponsor a Child</a>
					</div>
				</section>

			</main>

		</article>
	}
}

export default GameInactive



// WEBPACK FOOTER //
// ./src/components/game/inactive.js